/* eslint-disable import/no-commonjs */
// ES6 polyfills!

require('core-js/stable/string/includes');
require('core-js/stable/array/from');
require('core-js/stable/array/find'); // IE10 shim
require('core-js/stable/array/find-index');
require('core-js/stable/array/flat-map');
require('core-js/stable/array/includes');
require('core-js/stable/object/assign');
require('core-js/stable/object/entries');
require('core-js/stable/object/from-entries'); // IE10 shim
require('core-js/stable/object/values');
require('core-js/stable/promise');
require('core-js/stable/promise/all-settled');
require('core-js/stable/promise/finally');
require('core-js/stable/function/bind'); // for PhantomJS 1.9.8 (E2E testing)
require('core-js/stable/string/starts-with');
require('core-js/stable/string/ends-with');
require('core-js/stable/symbol'); // used by react-tooltip
require('core-js/stable/map'); // IE10 shim
require('core-js/stable/weak-map');
require('core-js/stable/set');
require('core-js/web/url'); // used by login app, needed for IE
require('whatwg-fetch');
require('abortcontroller-polyfill');
require('raf/polyfill'); // Required for React 16+ and IE 10+
